import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { forkJoin } from 'rxjs';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { DealershipDto } from 'src/app/shared/models/dealership/dealership-dto';
import { DistributorDto } from 'src/app/shared/models/distributor/distributor-dto';
import { UserNoIdDto } from 'src/app/shared/models/user/user-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import { UserFormComponent } from '../components/user-form/user-form.component';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    standalone: false
})
export class CreateUserComponent {
  @ViewChild(UserFormComponent) userForm: UserFormComponent;

  loading = false;

  constructor(private readonly router: Router, private readonly userService: UserService, private readonly alertService: AlertService) {}

  get form(): FormGroup {
    return this.userForm?.form;
  }

  get values(): any {
    return this.form?.value;
  }

  setLoading(state: boolean) {
    this.loading = state;
  }

  submitForm() {
    if (this.form.invalid) {
      return this.alertService.showAlert({ type: 'critical', content: 'Preencha o formulário corretamente.' } as Alert);
    }

    if (this.values?.password != this.values?.passwordConfirm) {
      return this.alertService.showAlert({ type: 'critical', content: 'As senhas não são iguais.' } as Alert);
    }

    const userData: UserNoIdDto = {
      userId: this.values?.email,
      userProfileId: this.values?.userProfile?.id,
      companyId: this.values?.company?.id,
      name: this.values?.name,
      userName: this.values?.email,
      password: this.values?.password,
      enabled: this.values?.enabled
    };

    this.loading = true;

    this.userService
      .create(userData)
      .subscribe({
        next: () => {
          this.router.navigate(['/users']).then(() => {
            this.alertService.showAlert({ type: 'success', content: 'Usuário cadastrado com sucesso.' } as Alert);
          });
        },
        error: () => {
          this.alertService.showAlert({ type: 'critical', content: 'Ocorreu um erro ao cadastrar o usuário.' } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
